export enum InscriptionStatus{
    PENDING_SOCIAL_SERVICES_APPROVEMENT = 3,
    COMPLETED = 5
}
